module.exports = __webpack_public_path__ + "img/hero-contact.05fdf66c.jpg";